export default __webpack_public_path__ + "static/media/3.98b9211a.JPG";